import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import PendoTable from '../../components/table/pendo-table.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';
import PendoCopyCodeBlock from '../copy-code-block/pendo-copy-code-block.vue.js';
import EditAction from './actions/edit-action.vue.js';
import RevokeAction from './actions/revoke-action.vue.js';
import moment from 'moment';
import get from 'lodash/get.js';

const MAXIMUM_ACTIVE_KEYS = 5;
var script = {
  name: 'ActiveKeys',
  components: {
    PendoAlert,
    PendoTable,
    PendoModal,
    PendoButton,
    PendoInput,
    PendoIcon,
    EditAction,
    RevokeAction,
    PendoCopyCodeBlock
  },
  directives: {
    PendoTooltip
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    appId: {
      type: [String, Number],
      default: '-323232'
    },
    newKeyName: {
      type: String,
      default: null
    },
    loadingState: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isModalVisible: false,
      modalAction: null,
      modalId: null,
      modalDescription: null,
      defaultSort: {
        prop: 'createdAt',
        order: 'descending'
      },
      columns: [{
        prop: 'id',
        label: 'Signing Key Name',
        sortable: true
      }, {
        prop: 'description',
        label: 'Description',
        width: '250px',
        sortable: true
      }, {
        prop: 'secret',
        label: 'Key',
        width: '500px',
        sortable: false
      }, {
        label: 'Created Time',
        prop: 'createdAt',
        sortable: true,
        formatter: row => moment(row.createdAt).format('MMM D, YYYY h:mm:ss A z')
      }, {
        label: 'Created By',
        prop: 'createdByUser.username',
        sortable: true
      }, {
        type: 'actions',
        width: '80px'
      }]
    };
  },
  computed: {
    modalTitle() {
      switch (this.modalAction) {
        case 'create':
          return 'Generate Key';
        case 'edit':
          return 'Edit Key Description';
        case 'revoke':
          return 'Confirm Revocation';
      }
      return;
    },
    modalIdLabel() {
      return this.modalAction === 'create' ? 'Signing Key Name Preview' : 'Signing Key Name';
    },
    confirmButtonConfig() {
      const actionDisabled = !this.modalDescription;
      switch (this.modalAction) {
        case 'create':
          return {
            type: 'primary',
            theme: 'app',
            label: 'Create',
            disabled: actionDisabled
          };
        case 'edit':
          return {
            type: 'primary',
            theme: 'app',
            label: 'Save',
            disabled: actionDisabled
          };
        case 'revoke':
          return {
            type: 'danger',
            theme: 'app',
            label: 'Revoke Key',
            disabled: actionDisabled
          };
      }
      return;
    },
    hasMaximumActiveKeys() {
      return get(this, 'tableData.length', 0) >= MAXIMUM_ACTIVE_KEYS;
    }
  },
  methods: {
    handleToggleSecret(row) {
      this.$refs.activetable.updateRow(_objectSpread2(_objectSpread2({}, row), {}, {
        showSecret: !row.showSecret
      }));
    },
    openModal(_ref) {
      let {
        action,
        id,
        description
      } = _ref;
      this.modalAction = action;
      this.modalId = id;
      this.modalDescription = description;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    confirmModal() {
      switch (this.modalAction) {
        case 'create':
          this.$emit('create', {
            kind: 'jwt',
            description: this.modalDescription,
            appId: this.appId
          });
          break;
        case 'edit':
          this.$emit('update', {
            id: this.modalId,
            description: this.modalDescription
          });
          break;
        case 'revoke':
          this.$emit('revoke', {
            id: this.modalId,
            description: this.modalDescription,
            revoked: true
          });
          break;
      }
      this.isModalVisible = false;
    }
  }
};

export { script as default };
//# sourceMappingURL=active-keys.vue2.js.map
